import React, { Component } from 'react';

import './dashboard.scss';

import { DashboardAPI, LayoutGap } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { arrayOf, element, oneOf, oneOfType, string  } from '@philips-emr/tws-core/lib/component/prop-types';
import { classNames, enumValues, getLostProps, propagateProps } from '@philips-emr/tws-utils';

const acceptedTypes = [
  ComponentType.BEHAVIOR,
  ComponentType.DATA_DISPLAY,
  ComponentType.LIST,
];

@AwesomeComponent({ type: ComponentType.LIST, api: DashboardAPI })
class Dashboard extends Component {
  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    className: string,
    uuid: string,
    rowGap: oneOf(enumValues(LayoutGap)).group('layout'),
    columnGap: oneOf(enumValues(LayoutGap)).group('layout'),
  };

  static defaultProps = {
    rowGap: LayoutGap.LARGE,
    columnGap: LayoutGap.LARGE,
  };

  getClassName() {
    const { className } = this.props;

    return classNames({
      'c-dashboard': true,
      'u-expand': true,
      [className]: Boolean(className),
    });
  }

  getStyle() {
    const { rowGap, columnGap } = this.props;

    return {
      gridRowGap: rowGap,
      gridColumnGap: columnGap,
    };
  }

  renderContent() {
    const { children } = this.props;

    const lostProps = getLostProps(Dashboard.propTypes, this.props);

    return propagateProps(children, lostProps);
  }

  render() {
    const { uuid } = this.props;
    const Container = ContainerProvider.provide(this);

    return (
      <Container acceptedTypes={acceptedTypes} className={this.getClassName()} style={this.getStyle()} uuid={uuid}>
        {this.renderContent()}
      </Container>
    );
  }
}

export default Dashboard;
